export const API = process.env.REACT_APP_BACKEND_URL;

export const mediaUrl = (path) => (path ? `${API}${path}` : null);

/** Avatar URLs are either external (Google) or relative /api/media paths. */
export const avatarSrc = (pic) => (pic?.startsWith("/api/") ? `${API}${pic}` : pic);

export const call = (path, opts = {}) => fetch(`${API}/api${path}`, { credentials: "include", ...opts });

export const getJson = async (path) => {
  try {
    const res = await call(path);
    return res.ok ? await res.json() : null;
  } catch {
    return null;
  }
};

export const errText = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e?.msg).join(" ") : "Algo salió mal. Inténtalo de nuevo.");

export const postForm = async (path, fields) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== "") fd.append(k, v); });
  const res = await call(path, { method: "POST", body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(errText(data?.detail));
  return data;
};
